<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
  <defs>
    <linearGradient id="a" x1="15" x2="1" y1="1" y2="15" gradientUnits="userSpaceOnUse">
      <stop stop-color="#0064FF"/>
      <stop offset="1" stop-color="#0037C5"/>
    </linearGradient>
  </defs>
  <path d="M9.3 5.5a1.2 1.2 0 0 1 1.2 1.2v2.6a1.2 1.2 0 0 1-1.2 1.2H6.7a1.2 1.2 0 0 1-1.2-1.2V6.7a1.2 1.2 0 0 1 1.2-1.2h2.6Z"/>
  <path fill="#fff" fill-opacity=".4" d="M8 14A6 6 0 1 1 8 2a6 6 0 0 1 0 12Zm0 1A7 7 0 1 0 8 1a7 7 0 0 0 0 14Z"/>
  <path fill="url(#a)" d="m8.479 2.017.02.002a6.002 6.002 0 0 1-.02 11.964.53.53 0 0 0-.479.518c0 .276.224.501.499.481l.082-.006.041-.004A7 7 0 0 0 8.5 1.018a.472.472 0 0 0-.5.481.53.53 0 0 0 .479.518Z"/>
</svg>